import axios from 'axios';

import { Carrier, Carriernote } from '../models/Carrier';
import { Class } from '../models/Class';
import { CrmCarrierOrder } from '../models/CrmCarrierOrder';
import { Insurance } from '../models/Insurance';
import { Mode } from '../models/Mode';
import { Option } from '../models/Option';
import { Rate, transformRateFromAPI } from '../models/Rate';
import { Rating } from '../models/Rating';
import { CarrierTerminals, Terminal } from '../models/Terminal';
import { Valuehistory } from '../models/Valuehistory';
import { Vehicle } from '../models/Vehicle';

const uri = '/carrier';

const create = async (carrier: Carrier) => {
  const { data } = await axios.post<Carrier>(`${uri}`, carrier);
  return data;
};

const get = async (id: number) => {
  const { data } = await axios.get<Carrier>(`${uri}/${id}`);
  return data;
};

const getAll = async () => {
  const { data } = await axios.get<Carrier[]>(`${uri}`);
  return data;
};

const getList = async () => {
  const { data } = await axios.get<Carrier[]>(`${uri}/list`);
  return data;
};

const update = async (carrier: Carrier) => {
  const { data } = await axios.put<Carrier>(`${uri}/${carrier.id}`, carrier);
  return data;
};

const remove = async (id: number) => {
  const { data } = await axios.delete(`${uri}/${id}`);
  return data;
};

const getModes = async (id: number) => {
  const { data } = await axios.get<Mode[]>(`${uri}/${id}/modes`);
  return data;
};

const getRating = async (id: number) => {
  const { data } = await axios.get<Rating | null>(`${uri}/${id}/rating`);
  return data;
};

const getInsurance = async (id: number) => {
  const { data } = await axios.get<Insurance | null>(`${uri}/${id}/insurance`);
  return data;
};

const getTerminals = async (id: number) => {
  const { data } = await axios.get<Terminal[]>(`${uri}/${id}/terminals`);
  return data;
};

const getClasses = async (id: number) => {
  const { data } = await axios.get<Class[]>(`${uri}/${id}/classes`);
  return data;
};

const getCrmCarrierOrders = async (carrier: Carrier) => {
  const { data } = await axios.get<CrmCarrierOrder[]>(
    `${uri}/${carrier.crmCarrierId}/crmCarrierOrders`
  );
  return data;
};

const getCarrierTerminalMap = async () => {
  const { data } = await axios.get<CarrierTerminals>(`${uri}/terminal`);
  return data;
};

const updateCarrierTerminalMap = async (carrierTerminals: CarrierTerminals) => {
  const { data } = await axios.put<CarrierTerminals>(
    `${uri}/terminal`,
    carrierTerminals
  );
  return data;
};

const getVehicles = async (id: number) => {
  const { data } = await axios.get<Vehicle[]>(`${uri}/${id}/vehicle`);
  return data;
};

const getSurchargeHistory = async (id: number) => {
  const { data } = await axios.get<Valuehistory[]>(
    `${uri}/${id}/surchargeHistory`
  );
  return data;
};

const getNotes = async (id: number) => {
  const { data } = await axios.get<Carriernote[]>(`${uri}/${id}/notes`);
  return data;
};

const getOption = async (id: number) => {
  const { data } = await axios.get<Option | null>(`${uri}/${id}/option`);
  return data;
};

const updateOption = async (option: Option) => {
  const { data } = await axios.post<Option>(
    `${uri}/${option.carrierId}/option`,
    option
  );
  return data;
};

const getRates = async (id: number) => {
  const { data } = await axios.get<Rate[]>(`${uri}/${id}/rate`);
  return data.map(transformRateFromAPI);
};

const createNote = async (note: Carriernote) => {
  const { data } = await axios.post<Carriernote>(
    `${uri}/${note.carrierId}/note`,
    note
  );
  return data;
};

const deleteNote = async (id: number) => {
  const { data } = await axios.delete(`${uri}/note/${id}`);
  return data;
};

const apis = {
  create,
  createNote,
  deleteNote,
  get,
  getAll,
  getCarrierTerminalMap,
  getClasses,
  getCrmCarrierOrders,
  getInsurance,
  getList,
  getModes,
  getNotes,
  getOption,
  getRates,
  getRating,
  getSurchargeHistory,
  getTerminals,
  getVehicles,
  remove,
  update,
  updateCarrierTerminalMap,
  updateOption,
};

export default apis;
